import { Text } from '@tectonic/elemason-components';
import { toCurrency } from '@tectonic/utils';
import { useHaloScript } from '../../../hooks/useHaloScript';

import type { ElemasonPriceRangeTextWidget } from '@tectonic/types';
import type { FC } from 'react';

interface ProductPriceRangeTextWidgetProps {
  widget: ElemasonPriceRangeTextWidget;
}

const ProductPriceRangeTextWidget: FC<ProductPriceRangeTextWidgetProps> = ({
  widget: { config, data },
}) => {
  const product = useHaloScript(data?.product);
  if (!product || !product.variants) return null;

  const minAmount = product.variants.reduce(
    (min, v) => (v.price.amount < min.amount ? v.price : min),
    product.variants[0].price
  );

  const maxAmount = product.variants.reduce(
    (max, v) => (v.price.amount > max.amount ? v.price : max),
    product.variants[0].price
  );

  const placeholders = {
    min: toCurrency(minAmount.amount, minAmount.currencyCode),
    max: toCurrency(maxAmount.amount, maxAmount.currencyCode),
  };

  return (
    <Text
      data={
        minAmount.amount === maxAmount.amount
          ? toCurrency(minAmount.amount, minAmount.currencyCode)
          : data?.text
      }
      config={config?.text}
      placeholders={placeholders}
    />
  );
};

export { ProductPriceRangeTextWidget };
